<template>
  <div>
    <app-header title="Devices">
      <b-button variant="primary" v-router-link="{name:'device-editor',params:{id:'new'}}">
        <i class="fa fa-plus-circle" /> New Device
      </b-button>
    </app-header>
    <loading-spinner v-if="!devices" />
    <b-container v-else>
      <b-row>
        <b-col>
          <search-input v-model="query" />
        </b-col>
        <b-col class="text-right">
          {{ total }} Devices
        </b-col>
      </b-row>
      <b-card-group columns>
        <b-card
          v-for="device in displayDevices"
          :key="device.id"
          v-router-link="{name:'device-detail',params:device}"
          no-body
        >
          <img :src="'https://cdn.gokaizen.com/' + device.src" alt="" style="max-width:100%;">
          <b-card-body>
            <h3>{{ device.name }}</h3>
            <p>{{ device.manufacturer_name }} ({{ device.type_name }})</p>
          </b-card-body>
        </b-card>
      </b-card-group>
      <infinite-scrolling @infiniteHandler="infiniteHandler" />
    </b-container>
  </div>
</template>

<script>
import $api from '@/services/api';
import $search from '@/services/search';
import SearchInput from '@/components/SearchInput';
import LoadingSpinner from '@/components/LoadingSpinner';
import InfiniteScrolling from '@/components/InfiniteScrolling';
import AppHeader from '@/components/AppHeader';

export default {
  components: {
    AppHeader,
    SearchInput,
    LoadingSpinner,
    InfiniteScrolling,
  },

  data() {
    return {
      query: '',
      devices: null,
      page: 0,
      perPage: 7,
    };
  },

  computed: {
    displayDevices() {
      return $search(this.devices, this.query, ['name', 'manufacturer_name']).slice(0, this.perPage * this.page);
    },

    total() {
      return (this.query) ? this.displayDevices.length : this.devices.length;
    },
  },

  created() {
    this.refreshData();
  },

  methods: {
    async refreshData() {
      this.devices = await $api.get('/v1/internal/devices');
    },

    infiniteHandler($state) {
      if ((this.perPage * this.page) <= this.devices.length) {
        this.page += 1;
        $state.loaded();
      } else {
        $state.complete();
      }
    },
  },
};
</script>
